import menuList from "./menuList"
/**
 * @param {工具方法封装*}  
 * @data 2019/8/6
 */
//时间戳转换
export const formatDate = (params) => {
    let date = new Date(parseInt(params) * 1000);
    let Y = date.getFullYear() + "-";
    let M = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) + "-" : date.getMonth() + 1 + "-";
    let D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " ";
    let h = date.getHours() < 10 ? "0" + date.getHours() + ":" : date.getHours() + ":";
    let m = date.getMinutes() < 10 ? "0" + date.getMinutes() + ":" : date.getMinutes() + ":";
    let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
}

// 时间戳转换为天
export const formatDay = (params) => {
    let date = new Date(parseInt(params) * 1000);
    let Y = date.getFullYear() + "-";
    let M = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) + "-" : date.getMonth() + 1 + "-";
    let D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " "; 
    return Y + M + D ;
}

// 装换为毫秒
export const formatTime = (params) => {
    let date = new Date(parseInt(params));
    let Y = date.getFullYear() + "-";
    let M = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) + "-" : date.getMonth() + 1 + "-";
    let D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " ";
    let h = date.getHours() < 10 ? "0" + date.getHours() + ":" : date.getHours() + ":";
    let m = date.getMinutes() < 10 ? "0" + date.getMinutes() + ":" : date.getMinutes() + ":";
    let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
}

// 获取系统时间加分钟
export const currentTime = () => {
    let date = new Date();
    let Y = date.getFullYear() + "-";
    let M = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) + "-" : date.getMonth() + 1 + "-";
    let D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " ";
    let h = date.getHours() < 10 ? "0" + date.getHours() + ":" : date.getHours() + ":";
    let m = date.getMinutes() < 10 ? "0" + date.getMinutes() + ":" : date.getMinutes() + ":";
    let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return Y + M + D;
}

//查看详情字段转换
export const fieldTransformation = (val) => {
    if (val == "username") {
        return "用户名";
    } else if (val == "gender") {
        return "性别";
    } else if (val == "id") {
        return "id";
    } else if (val == "birthday") {
        return "生日";
    } else if (val == "register_time") {
        return "注册时间";
    } else if (val == "last_login_time") {
        return "最后登录的时间";
    } else if (val == "last_login_ip") {
        return "ip";
    } else if (val == "user_level_id") {
        return "用户级别id";
    } else if (val == "nickname") {
        return "昵称";
    } else if (val == "readername") {
        return "设备号";
    } else if (val == "register_ip") {
        return "注册知识产权";
    } else if (val == "avatar") {
        return "图片";
    } else if (val == "weixin_openid") {
        return "微信ID";
    } else if (val == "mobile") {
        return "电话";
    }
}

//时间转时间戳
export const turnTimestamp = (time) => {
    var thisTime = time;
    thisTime = thisTime.replace(/-/g, '/');
    var time = new Date(thisTime);
    let times = time.getTime() / 1000;
    return times
}

//格林尼治时间转换
export const GMTToStr = (time) => {
    let date = new Date(time)
    let Str = date.getFullYear() + '-' +
        (date.getMonth() + 1) + '-' +
         date.getDate() + ' ' +
         date.getHours() + ':' +
         date.getMinutes() + ':' +
         date.getSeconds()
    return Str
}

//订单判断条件
export const OrderJudgmentCondition = (data) => {
    let newData = []
    data.map(item => {
        if (item.pay_status == 0) {
            newData.push(item)
        }
    })
    console.log(newData);
    return newData
}

//分页
export const page = (pageSize, total, pageNum) => {
    var pageSize = pageSize;//每页数据条数
    var pageTotal = Math.ceil(total / pageSize);//总共多少页
    var pageNum = pageNum - 1 || 0;//页码pageNum-1是因为pageNum初始值一般为1
    function cutArry() {//数组切割
        let arr = [];
        for (let i = 0; i < pageTotal; i++) {
            let len = pageSize;
            let strat = i * len;
            let end = strat + len;
            arr.push(data.slice(strat, end));
        }
        return arr;
    }
}

//获取当月第一天和最后一天
export const getNowMonthDate = (mon) => {
    var date = new Date();
    var year = date.getFullYear() + "";
    var month = date.getMonth()  < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1; 

    // 上一个月
    var lastMonth = date.getMonth() < 10 ? "0" + (date.getMonth()) : date.getMonth();
    var last = ((lastMonth == 0) ? (12) : (lastMonth));
    var lastyear = (date.getMonth()==0) ? (year-1) : (year)

    // 本月第一天日期
    var begin = year + "-" + month + "-01" 

    // 上个月第一天
    var lastbegin = lastyear + "-" + last + "-01"   

    // 上个月最后一天
    var DateOfCurrentMonth = new Date(lastyear, last, 0);
    var lastend = lastyear + "-" + last + "-" + DateOfCurrentMonth.getDate();

    // 本月最后一天日期 
    var lastDateOfCurrentMonth = new Date(year, month, 0);
    var end = year + "-" + month + "-" + lastDateOfCurrentMonth.getDate();
    var obj = { begin, end, month, lastMonth, lastbegin, lastend, year, last, lastyear , date } 
    return obj;
    
}

//生成唯一id
export const generateId = (length) => {
    return ( length || '' ) + new Date().getTime().toString(36) + Math.random().toString(36).slice(2);
}

//拼接后台返回路由信息 
//递归 生成树形结构
export const generateTreeStructure = (data) =>{
    let cloneData = JSON.parse(JSON.stringify(data))      // 对源数据深度克隆
    return  cloneData.filter(father=>{                      // 循环所有项，并添加children属性
        let branchArr = cloneData.filter(child=> father.menu_id == child.menu_parent_id);   // 返回每一项的子级数组
        branchArr.length>0 ? father.children=branchArr : ''   //给父级添加一个children属性，并赋值
        return father.menu_parent_id==0;      //返回第一层
    });
}

//处理返回的menu路由信息
export const processRoutingStructure = (data) =>{
    let newData = data.map(item =>{
        if(item.children){
            let menus = {
                id:item.menu_id,
                path: '/',
                component: menuList('/Home'),
                name: item.route.name,
                iconCls: item.iconCls,
                children: item.children.map(val =>{
                    let childobj = {
                        id:val.menu_id,
                        path:val.route.path,
                        component:menuList(val.route.component),
                        name:val.route.name
                    }
                    return childobj
                })
            }
            return menus 
        }else{
            let menu = {
                id:item.menu_id,
                path: '/',
                component: menuList('Home'),
                name: item.route.menu_name,
                iconCls: item.iconCls,
            }
            return menu
        }
    })
    return newData
}


// WEBPACK FOOTER //
// ./src/utils/index.js